export enum RECONFIRMATION_STATES_ENUM {
    PENDIENTE_EXAMEN = 'pendiente-examen',
    PENDIENTE_PRESTADOR = 'pendiente-prestador',
    PENDIENTE_CONVOCATORIA = 'pendiente-convocatoria',
    CONVOCADO = 'convocado',
    RESULTADOS = 'resultados'
}
